import LegalLayout from "@/components/LegalLayout";
import { COMPANY } from "@/lib/legalData";

export default function CookiePolicy() {
  return (
    <LegalLayout title="Cookie Policy" slug="/cookie-policy">
      <p className="lead">
        La presente informativa descrive l'utilizzo di cookie e tecnologie similari sulla Piattaforma {COMPANY.brand}, ai sensi del Provvedimento del Garante per la Protezione dei Dati Personali del 10 giugno 2021 e delle Linee Guida sull'utilizzo dei cookie.
      </p>

      <h2>1. Cosa sono i cookie</h2>
      <p>
        I cookie sono piccoli file di testo che i siti web visitati inviano al browser dell'utente, dove vengono memorizzati per essere ritrasmessi al sito alla visita successiva. La Piattaforma utilizza inoltre tecnologie similari (<b>localStorage</b>) per finalità tecniche di autenticazione.
      </p>

      <h2>2. Tipologie di cookie utilizzati</h2>
      <p>
        {COMPANY.brand} utilizza <b>esclusivamente cookie e tecnologie di tipo tecnico</b>, necessari al funzionamento del servizio e all'autenticazione dell'utente. <b>Non sono utilizzati cookie di profilazione, di tracciamento pubblicitario o di analytics di terze parti</b>.
      </p>

      <h3>2.1 Cookie/storage tecnici (essenziali)</h3>
      <table>
        <thead>
          <tr><th>Nome</th><th>Tipologia</th><th>Finalità</th><th>Durata</th></tr>
        </thead>
        <tbody>
          <tr>
            <td><code>gs_token</code></td>
            <td>localStorage</td>
            <td>Mantenere l'utente autenticato (JWT) dopo il login (consulente/superadmin)</td>
            <td>30 giorni</td>
          </tr>
          <tr>
            <td><code>gs_client_profile</code></td>
            <td>localStorage</td>
            <td>Memorizzare i dati anagrafici del Cliente per il riempimento automatico delle pratiche future</td>
            <td>Persistente fino a cancellazione manuale</td>
          </tr>
          <tr>
            <td><code>gs_client_token</code></td>
            <td>localStorage</td>
            <td>Token di sessione per i Clienti</td>
            <td>30 giorni</td>
          </tr>
        </tbody>
      </table>
      <p>
        Ai sensi dell'art. 122 del D.Lgs. 196/2003, i cookie tecnici <b>non richiedono il consenso preventivo</b> dell'utente, in quanto strettamente necessari all'erogazione del servizio richiesto dall'utente stesso.
      </p>

      <h2>3. Cookie di terze parti</h2>
      <p>
        La Piattaforma <b>non utilizza</b> alcun cookie di terze parti per finalità di:
      </p>
      <ul>
        <li>Pubblicità o remarketing</li>
        <li>Analytics (es. Google Analytics, Meta Pixel)</li>
        <li>Social network</li>
        <li>Profilazione comportamentale</li>
      </ul>
      <p>
        Eventuali contenuti embedded (es. mappa Google Maps nelle pagine di dettaglio pratica) sono caricati con politica privacy-respecting; per ulteriori dettagli si rinvia alle informative dei rispettivi fornitori.
      </p>

      <h2>4. Gestione e disattivazione</h2>
      <p>
        L'utente può comunque, in qualsiasi momento, eliminare i dati memorizzati dal browser tramite le impostazioni del proprio browser:
      </p>
      <ul>
        <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noreferrer">Google Chrome</a></li>
        <li><a href="https://support.mozilla.org/it/kb/Gestione%20dei%20cookie" target="_blank" rel="noreferrer">Mozilla Firefox</a></li>
        <li><a href="https://support.apple.com/it-it/HT201265" target="_blank" rel="noreferrer">Safari (iOS / macOS)</a></li>
        <li><a href="https://support.microsoft.com/it-it/microsoft-edge" target="_blank" rel="noreferrer">Microsoft Edge</a></li>
      </ul>
      <p>
        Si avverte tuttavia che la disattivazione dei cookie tecnici essenziali potrebbe impedire il corretto funzionamento della Piattaforma (impossibilità di mantenere il login, perdita dei dati anagrafici memorizzati).
      </p>

      <h2>5. Modifiche</h2>
      <p>
        Il Titolare si riserva il diritto di aggiornare la presente Cookie Policy per adeguarla all'evoluzione normativa o all'introduzione di nuove tecnologie. Le modifiche saranno pubblicate su questa pagina.
      </p>
    </LegalLayout>
  );
}
